<div class="w-full py-3 px-2 lg:px-4">
  <div class="w-full p-4 mb-4 bg-white rounded-md shadow border border-gray-200">
    <!-- Title -->
    <div class="flex justify-center mb-6">
      <h2
        class="text-base sm:text-lg lg:text-xl font-semibold text-[#c19725] relative inline-block text-center
             before:content-[''] before:absolute before:-bottom-2 before:left-1/2 before:-translate-x-1/2
             before:w-16 before:h-0.5 before:rounded-full before:bg-gradient-to-r before:from-yellow-400 before:to-[#c19725]">
        Customize Settings
      </h2>
    </div>

    <!-- Section for Main Menu Visibility -->
    <div class="mb-8">
      <h3 class="text-sm sm:text-base lg:text-lg font-semibold text-[#c19725] mb-4">Main Menu Visibility</h3>

      <!-- Select/Unselect Buttons -->
      <div class="max-w-2xl mx-auto flex justify-center gap-2 sm:gap-2.5 md:gap-3 mb-6">
        <button type="button"
          class="px-2.5 lg:px-4 py-1.5 bg-green-600 text-white text-sm font-medium rounded-md shadow hover:bg-green-700 transition"
          (click)="selectAllMainMenu()">
          Select All
        </button>
        <button type="button"
          class="px-2.5 lg:px-4 py-1.5 bg-red-600 text-white text-sm font-medium rounded-md shadow hover:bg-red-700 transition"
          (click)="unselectAllMainMenu()">
          Unselect All
        </button>
      </div>

      <!-- Checkboxes -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        <div *ngFor="let item of mainMenuItems">
          <label
            class="flex items-center space-x-2 p-3 bg-gray-50 rounded-md border border-gray-200 hover:bg-gray-100 transition duration-200"
            [ngClass]="{
              'cursor-not-allowed opacity-70': item.path === '/home' || item.path === '/dropdown-settings'
            }">
            <input
              type="checkbox"
              [checked]="item.visible"
              [disabled]="item.path === '/home' || item.path === '/dropdown-settings'"
              (change)="item.visible = !item.visible"
              class="form-checkbox h-4 w-4 accent-[#c19725] cursor-pointer disabled:cursor-not-allowed" />
            <span class="text-sm text-gray-800 font-medium">{{ item.lable }}</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Section for Submenu Visibility -->
    <div class="mb-8">
      <h3 class="text-sm sm:text-base lg:text-lg font-semibold text-[#c19725] mb-4">Submenu Visibility</h3>
      <!-- Select/Unselect Buttons -->
      <div class="max-w-2xl mx-auto flex justify-center gap-2 sm:gap-2.5 md:gap-3 mb-6">
        <button type="button"
          class="px-2.5 lg:px-4 py-1.5 bg-green-600 text-white text-sm font-medium rounded-md shadow hover:bg-green-700 transition"
          (click)="selectAllSubmenu()">
          Select All
        </button>
        <button type="button"
          class="px-2.5 lg:px-4 py-1.5 bg-red-600 text-white text-sm font-medium rounded-md shadow hover:bg-red-700 transition"
          (click)="unselectAllSubmenu()">
          Unselect All
        </button>
      </div>
      <!-- Grouped Checkboxes -->
      <div class="space-y-6">
        <div *ngFor="let group of submenuGroups">
          <h3 class="text-sm sm:text-base lg:text-lg font-semibold text-[#c19725] mb-2 pl-1">{{ group.parentLabel }}</h3>
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            <div *ngFor="let item of group.submenu">
              <label
                class="flex items-center space-x-2 p-3 bg-gray-50 rounded-md border border-gray-200 hover:bg-gray-100 transition duration-200 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="item.visible"
                  (change)="toggleSubItem(item.path, group.parentPath)"
                  class="form-checkbox h-4 w-4 accent-[#c19725]" />
                <span class="text-sm text-gray-800 font-medium">{{ item.lable }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ================= PREFIX SECTION ================= -->
<div class="mb-8">
  <h3 class="text-sm sm:text-base lg:text-lg font-semibold text-center text-[#c19725] mb-4">
    Product Code Prefixes
  </h3>
  <form [formGroup]="prefixForm">
    <div class="lg:w-1/2 xl:w-2/3 mx-auto grid grid-cols-1 sm:grid-cols-4 gap-2 sm:gap-2.5 md:gap-3">
      <input
        type="text"
        formControlName="customize_metal_prefix"
        placeholder="Enter Metal prefix"
        autocomplete="off"
        (keydown.enter)="focusNext($event)"
        class="flex-1 px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm"
      />
      <input
        type="text"
        formControlName="customize_stone_prefix"
        placeholder="Enter Stone prefix"
        autocomplete="off"
        (keydown.enter)="focusNext($event)"
        class="flex-1 px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm"
      />
      <input
        type="text"
        formControlName="customize_ready_product_prefix"
        placeholder="Enter Lot prefix"
        autocomplete="off"
        (keydown.enter)="focusNext($event)"
        class="flex-1 px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm"
      />
      <input
        type="text"
        formControlName="customize_barcode_prefix"
        placeholder="Enter Barcode prefix"
        autocomplete="off"
        (keydown.enter)="focusNext($event)"
        class="flex-1 px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm"
      />
    </div>
  </form>
</div>

    <!-- Main Action Buttons (Back and Save) -->
    <div class="max-w-2xl mx-auto flex justify-center gap-2 sm:gap-2.5 md:gap-3 mt-10 mb-6">
      <button type="button"
          class="block cursor-pointer capitalize w-[80px] lg:w-[100px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-c19725 bg-white border border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center"
          routerLink="/product-creation"> <!-- Assuming this is the correct back link -->
          Back
      </button>

      <!-- *** THE FIX IS HERE *** -->
      <!-- This single button now saves all settings on the page -->
      <button type="button"
        class="px-2 lg:px-4 py-2 bg-[#c19725] text-white text-base xl:text-lg rounded-md shadow hover:bg-yellow-700 transition"
        (click)="saveAllChanges()">
        Save Settings
      </button>
    </div>
  </div>
</div>
